import React, { useEffect, useState } from "react";
import style from "./list.module.sass";
import "./style.scss";
import { Modal } from "../../../helpers/commonUi";
import { useToast } from "../../../helpers/commonFunction";
import { Input, Popover,Tooltip } from "antd";
import { ReactComponent as SearchIcon } from "../../../assets/svg/search.svg";
import { ReactComponent as CloseCricleOutlined } from "../../../assets/svg/closeCricleOutlined.svg";
import { useParams } from "react-router-dom";
import {useSelector } from 'react-redux';
import { Http } from "../../../helpers/axois";
import NoData from "../NoData";
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
import { AppState } from "../../../stateManager/store";
interface FormBind {
  [key: string]: boolean
}

export const SecureVariables = () => {
  const { SuccessToast, ErrorToast } = useToast();
  const [popOpen, setPopOpen] = useState<boolean>(false);
  const [formBindList, setFormBindList] = useState<FormBind>({});
  const [inputVariable, setInputVariable] = useState<string | null>(null);
  const [filteredBindList, setFilteredBindList] = useState(formBindList); 
  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalValue, setModalValue] = useState<string| null>(null);
  const [secureVariables, setSecureVariables] = useState<string[]>([]);
  const [warning, setWarning] = useState(false);
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
}, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
var canEdit =  (orgPermissions.includes('app.View') && orgPermissions.includes('acl.Edit')) || loggedInUserId==selectedOrg?.owner;
var canAccess =  (orgPermissions.includes('app.View') && orgPermissions.includes('acl.View')) ||  loggedInUserId==selectedOrg?.owner;
  const params: { appId?: string } = useParams();
  const appId = params.appId;

  const versionId = useSelector((state: any) => {
    if (appId && state.apps?.appVersion?.[appId]) {
      return state.apps.appVersion[appId].versionId;
    } else {
      return null;
    }
  });

  const branchId = useSelector((state: any) => {
    if (appId && state.apps?.appBranch?.[appId]) {
      return state.apps.appBranch[appId].branchId;
    } else {
      return null;
    }
  });

  const title= "Secure Variables";
  const description = `Variables of type String, JSON, and Object can be secured by storing them as encrypted values in the database. 
  You can select variables from forms or add new ones, with support for pattern matching using '*'. 
  Variables prefixed with '_sec_' are auto encrypted. Filtering tasks or sessions with secure variables in the runtime is supported only with the equality ('=') operator.`;

  useEffect(() => {
    Http.get(`/apps/${appId}/variables?versionId=${versionId}`)
        .subscribe((res: any) => {
            const mappedBindList: FormBind = {}
            res.forEach((item: any) => {
                mappedBindList[item.bind] = false
            });
            getSecureVariables(mappedBindList);
        }, (err) => {
          if (err == "Forbidden") {
              canAccess = false
          }
      });
}, [versionId, branchId]);

  const getSecureVariables = (bindList?: any) => {
    if(!canAccess){
      ErrorToast("Not Authorized: Error getting secure variables")
      return
    }
    Http.get( `/apps/${appId}/secure-variables?versionId=${versionId}`
    ).subscribe((res: any) => {
      //updateFormBindList based on variables response
      let updatedFormBindList: FormBind = {}
      if (!bindList) {
        bindList = formBindList
      }
      for (let k in bindList) {
        updatedFormBindList[k] = res?.variables?.includes(k)
      }
      
      setFormBindList(updatedFormBindList);
      setSecureVariables(res.variables);
    }, (err) => {
      if (err == "Forbidden") {
          canAccess = false
      }
  });
  };

  const createSecureVariable = (variableName: string) => {
    if(!canEdit){
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    }
    Http.put(`/apps/${appId}/secure-variables?versionId=${versionId}`,
      {
        add: [variableName],
      }
    ).subscribe((response) => {
        if(response) {
          setPopOpen(false)
          getSecureVariables();
          SuccessToast("Secure Variable created successfully");
          setInputVariable(null);
        } else{
          ErrorToast('Secure variable update failed')
        }
      }, (err) => {
        if (err == "Forbidden") {
            canEdit = false
        }
    });
  };


  const deleteSecureVariable = (variableName: string) => {
    if(!canEdit){
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    }
    Http.put(`/apps/${appId}/secure-variables?versionId=${versionId}`,
      {
        remove: [variableName],
      }
    ).subscribe(
      (response) => {
        if (response) { // Assuming API response has a 'success' flag
          setInputVariable(null);
          getSecureVariables();
          SuccessToast("Secure Variable deleted successfully");
        }else{
          ErrorToast('Secure variable update failed');
        }
      }, (err) => {
        if (err == "Forbidden") {
            canEdit = false
        }
    }
    );
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputVariable(value);

    let filteredList: FormBind = {}
    if (value) {
      for (let k in formBindList) {
        if (k.toLowerCase().includes(value.toLowerCase()))
          filteredList[k] = formBindList[k]
      }
    } else {
      filteredList = formBindList
    }
    setFilteredBindList(filteredList);
  };

  const handleInputRestrictions = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = /^[a-zA-Z0-9-_*]$/;
    const controlKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"];
    if (inputVariable && inputVariable.length >= 100 && !controlKeys.includes(e.key)) {
      setWarning(true)
      setPopOpen(false)
      e.preventDefault();  
    } else {
      setWarning(false)
    }
    
    if (!allowedKeys.test(e.key) && !controlKeys.includes(e.key)) {
      e.preventDefault();
    }

    if (e.key === "Enter") {
      setPopOpen(false);
      inputVariable && createSecureVariable(inputVariable);
    }
  };

  const handleVisibleChange = (visible: boolean) => {
    setPopOpen(visible);
  }; 

  const content = (
    <div style={{ fontFamily: "Mulish" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "space-between",
          maxHeight: Object.keys(filteredBindList).length > 0 ? "367px" : "100px",
          width: "360px",
          margin: "-1px 0 0 -1px",
          overflow: Object.keys(filteredBindList).length > 0 ? "auto" : "visible",
          rowGap: "10px",
        }}
      >
        {Object.keys(filteredBindList).length > 0 ? (
          (Object.keys(filteredBindList)).map((formBindValue, index) => {
            const isAdded = formBindList[formBindValue];
            return (
              <div
                key={index}
                data-test-id={`form_bind`}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span
                data-test-id={`form_bind_value`}
                  style={{
                    fontSize: 14,
                    fontWeight: isAdded ? 600 : 400,
                    color: isAdded ? "#292D32" : "#6E747C",
                  }}
                >
                  {formBindValue.length > 30 ? (formBindValue.slice(0,30) + "...") : formBindValue}
                </span>
                <span
                    data-test-id = {isAdded ? "remove_form_bind" : "add_form_bind"}
                    style={{
                      marginRight: "4px",
                      cursor: "pointer",
                      fontSize: 12,
                      fontFamily: "Mulish",
                      fontWeight: 600,
                      color: isAdded ? "#FF4545" : "#6E747C",
                    }}
                    onClick={() => {
                      if (isAdded) {
                        setModalValue(formBindValue)
                        setModalVisibility(true);
                        setPopOpen(false);
                      } else {
                        createSecureVariable(formBindValue)
                      }
                    }}
                  >
                  {isAdded ? <>Remove</> : <>Add</>}
                </span>
              </div>
            );
          })
        ) : (
          <span
          data-test-id="no_data"
            style={{
              color: "#bfbfbf",
              fontSize: 14,
              fontFamily: "Mulish",
              height: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No Data
          </span>
        )}
      </div>
    </div>
  );

  return (
    <div className="viewWrapper">
      {canAccess ? <div className={"row " + style.data}>
        <div className= "secure-asset__container">
        <div className={style.header}>
          <div className={style.first}>
            <h4 data-test-id="title">{title}</h4>
            <h5 data-test-id="description">{description }</h5>
          </div>
          <div style={{ paddingBottom: 10, cursor: "pointer"}}>
            { <Popover overlayClassName="securePop"
            data-test-id="popover"
            placement="bottomLeft"
            trigger="click"
            visible={popOpen}
            onVisibleChange={handleVisibleChange}
            content={content}>
            <Input  
              data-test-id="input"
              className={"secure-asset__container--search"}
              prefix={<SearchIcon style={{width:"16px",height:"16px",marginLeft:"-2px"}}/>}
              placeholder="Search to add variables"
              value={inputVariable || ""}
              onChange={handleInputChange}
              onKeyDown={handleInputRestrictions}
              onClick={() =>{
                setFilteredBindList(formBindList);  
                setPopOpen((prev) => !prev);
              }}
            />
            
            </Popover>}
             <div data-test-id="warning" style={{color:"#FF4545",  visibility: warning ? "visible" : "hidden", marginTop:"2px"}}>
              Cannot exceed maximum character length 100
              </div>
          </div>
        </div>
        <hr style={{ border: "1px solid #95ABD34D",transform: "rotate(-0deg)", margin: "9px 16px 0 16px"}}/>
        <div  className={style.variable}>
        {secureVariables && secureVariables.map((value, index) => (
           <Tooltip key={index} placement="topLeft" title={value.length > 20 ? value : null}>
            <div key={index} data-test-id={`secure_variable`} className={style.item} style={{ display: "flex", alignItems: "center", maxWidth: "184px" }}>
            <span style={{whiteSpace: "nowrap", textOverflow: "ellipsis", "overflow": "hidden"}}>{value}</span>
            <CloseCricleOutlined className={style.closeIcon} data-test-id={`close_icon_${index}`} onClick={() => (setModalValue(value), setModalVisibility(true), setPopOpen(false))} />
            </div>
          </Tooltip>  
        ))}   
        </div>  
        <Modal 
         id="deleteSecureVariable"
         dataTestId="delete_secure_variable"
         key="deleteSecureVariable"
         visible={modalVisibility}
         title="DELETE VARIABLE" 
         onCancel={() => {
           setModalVisibility(false)
         }}
         footer={{
             enable: true,
             okText: 'SUBMIT',
             cancelText: 'CANCEL',
             OkButtonColor: "shadow-secondary",
             onOk: () => {
               modalValue && deleteSecureVariable(modalValue)
               setModalVisibility(false);
             }
         }}
         unmountOnCancel={true}
     >
         <div style={{height:'auto',padding:"20px 20px 20px 20px"}}>
         <p style={{marginBottom:0, marginLeft:"-6px",fontFamily: 'Mulish, sans-serif', fontSize: '14px', fontWeight: 400, lineHeight: '17.57px'}}>
         {"Do you prefer to remove the variable -"} <span style={{fontFamily: 'Mulish, sans-serif', fontSize: '14px', fontWeight: 700, padding: "0px -1px 0px 5px", marginTop:"2px",color:"#052f35 "}}>{modalValue}</span>
         </p>
         </div>
         </Modal>   
        </div>
      </div> :
       <NoData 
       svg={WarningIcon}
       header='Not Authorized'
       content='Please request owner of this organization to provide access'
       noButton={true}
   /> }
    </div>
  );
};